import { createApp } from "vue";
import App from "./App.vue";

// Element Plus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueAudioPlayer from 'vue-audio-player'

// 请求 API（保持你的写法）
import {
  deleteRequest,
  downPostRequest,
  getRequest,
  postRequest,
  putRequest,
} from "@/config/request";

// router & store（Vue Router 4 / Vuex 4 必须是 Vue3 专用版本）
import router from "./router";
import store from "./store";

// 样式
import "/src/theme/index.scss";

// 翻译插件 i18n-jsautotranslate
import translate from "i18n-jsautotranslate";
translate.setUseVersion2();
translate.selectLanguageTag.show = false;
translate.listener.start();

import Editor from '@/components/Form/Editor.vue'
import ImageUpload from '@/components/Form/ImageUpload.vue'
import FileUpload from '@/components/Form/FileUpload.vue'
import ImagePreview from '@/components/Form/ImagePreview.vue'
import Pagination from '@/components/Pagination/index.vue';
// 创建 Vue3 App 实例
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册全局方法（Vue3 等同于 Vue.prototype.xxx）
app.config.globalProperties.getRequest = getRequest;
app.config.globalProperties.postRequest = postRequest;
app.config.globalProperties.deleteRequest = deleteRequest;
app.config.globalProperties.putRequest = putRequest;
app.config.globalProperties.downPostRequest = downPostRequest;
app.config.globalProperties.$translate = translate;

app.use(ElementPlus, {
  locale: zhCn,
});
app.use(VueAudioPlayer)
app.use(router);
app.use(store);

// 注册全局组件
app.component('Editor', Editor)
app.component('ImageUpload', ImageUpload)
app.component('FileUpload', FileUpload)
app.component('ImagePreview', ImagePreview)
app.component('Pagination', Pagination)

// 路由守卫（Vue3 和 Vue2 写法一样）
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    console.log(to.name);
    
    if (["login", "register", "forgot", 'quotationIndex'].includes(to.name)) {
      next();
    } else {
      next("/login");
    }
  } else {
    if (["login", "register", "forgot"].includes(to.name)) {
      next("/quotation/index");
    } else {
      next();
    }
  }
});
app.mount("#app");
